<ng-container
  *ngIf="{
    product: product$ | async,
  } as content"
>
  @if (readonly) {
    @if (currentWarehouse) {
      <div class="edit-box">
        <button class="btn-check btn-link w-fit d-flex read-only" title="{{ 'cart.cartItems.warehouseHover' | cxTranslate }}">
          <span class="title">
            {{ 'inventory.label' | cxTranslate }}
          </span>
          :
          <span class="m-l-4 value"> {{ currentWarehouse.warehouseName }} </span>
        </button>
      </div>
    }
  } @else {
    @if (!content.product?.discontinued) {
      @if (!currentWarehouse) {
        <div class="add-warehouse">
          <button class="btn-check btn-link w-fit d-flex" (click)="openModal()">
            <span class="icon-check material-symbols-outlined d-flex m-r-4"> inventory </span>
            <span class="title">{{ 'inventory.action' | cxTranslate }}</span>
          </button>
        </div>
      } @else {
        <div class="edit-box">
          <button class="btn-check btn-link w-fit d-flex" (click)="openModal()" title="{{ 'inventory.title' | cxTranslate }}">
            <span class="icon-check material-symbols-outlined d-flex m-r-4"> edit </span>
            <span class="title">
              {{ 'inventory.label' | cxTranslate }}
            </span>
            :
            <span class="m-l-4 value"> {{ currentWarehouse.warehouseName }} </span>
          </button>
        </div>
      }
    }
  }
</ng-container>
